import { render, staticRenderFns } from "./ProcessingAndManagedManagement.vue?vue&type=template&id=5811f3b8&scoped=true&"
import script from "./ProcessingAndManagedManagement.vue?vue&type=script&lang=ts&"
export * from "./ProcessingAndManagedManagement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5811f3b8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VStepperContent,VStepperStep})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5811f3b8')) {
      api.createRecord('5811f3b8', component.options)
    } else {
      api.reload('5811f3b8', component.options)
    }
    module.hot.accept("./ProcessingAndManagedManagement.vue?vue&type=template&id=5811f3b8&scoped=true&", function () {
      api.rerender('5811f3b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/incidents/processing-and-managed-management/views/ProcessingAndManagedManagement.vue"
export default component.exports